import { isRouteErrorResponse, useRouteError, Link } from 'react-router-dom';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Route-level error element wired into the data router via `errorElement`.
 * A thrown error or failed loader inside a single route renders this instead
 * of tearing down the whole app, and the user keeps the shell/navigation.
 */
export function RouteError() {
  const error = useRouteError();

  let title = 'Không tải được trang';
  let detail = 'Trang này gặp sự cố. Bạn có thể thử lại hoặc quay về trang chủ.';

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    detail =
      error.status === 404
        ? 'Không tìm thấy nội dung bạn yêu cầu.'
        : 'Máy chủ trả về lỗi khi tải trang này.';
  } else if (error instanceof Error) {
    detail = error.message || detail;
  }

  return (
    <div
      role="alert"
      className="flex min-h-[60vh] w-full flex-col items-center justify-center gap-6 px-6 text-center"
    >
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10 text-destructive">
        <AlertTriangle className="h-7 w-7" aria-hidden="true" />
      </div>
      <div className="space-y-2">
        <h1 className="text-xl font-semibold text-foreground">{title}</h1>
        <p className="max-w-md text-sm text-muted-foreground">{detail}</p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Button onClick={() => window.location.reload()}>
          <RefreshCw className="h-4 w-4" aria-hidden="true" />
          Thử lại
        </Button>
        <Button variant="outline" asChild>
          <Link to="/">
            <Home className="h-4 w-4" aria-hidden="true" />
            Về trang chủ
          </Link>
        </Button>
      </div>
    </div>
  );
}

export default RouteError;
